import { createSelector } from '@ngrx/store';
import {
  selectUserAccessManagementState,
  selectError,
  selectCurrentRule,
  selectLoading,
  selectIpWhitelist,
} from './user-access-management.reducer';

// IP Whitelist Selectors
export const selectIpWhitelistItems = createSelector(
  selectIpWhitelist,
  ipWhitelist => ipWhitelist.items
);

export const selectIpWhitelistSelectedDetail = createSelector(
  selectIpWhitelist,
  ipWhitelist => ipWhitelist.selectedDetail
);

export const selectIpWhitelistEnabled = createSelector(
  selectIpWhitelist,
  ipWhitelist => ipWhitelist.enabled
);

export const selectIpWhitelistLoading = createSelector(
  selectIpWhitelist,
  ipWhitelist => ipWhitelist.loading
);

export const selectIpWhitelistDetailLoading = createSelector(
  selectIpWhitelist,
  ipWhitelist => ipWhitelist.detailLoading
);

export const selectIpWhitelistError = createSelector(
  selectIpWhitelist,
  ipWhitelist => ipWhitelist.error
);

export const selectIpWhitelistPagination = createSelector(
  selectIpWhitelist,
  ipWhitelist => ({
    currentPage: ipWhitelist.currentPage,
    pageSize: ipWhitelist.pageSize,
    totalItems: ipWhitelist.totalItems,
    totalPages: ipWhitelist.totalPages,
  })
);

export const selectIpWhitelistHasData = createSelector(
  selectIpWhitelistItems,
  items => items.length > 0
);

export const selectIpWhitelistShowDetailModal = createSelector(
  selectIpWhitelistSelectedDetail,
  detail => detail !== null
);

// User List Selectors
export const selectUserList = createSelector(
  selectUserAccessManagementState,
  state => state.userList
);

export const selectUserListUsers = createSelector(
  selectUserList,
  userList => userList.users
);

export const selectUserListLoading = createSelector(
  selectUserList,
  userList => userList.loading
);

export const selectUserListError = createSelector(
  selectUserList,
  userList => userList.error
);

export const UserAccessManagementSelectors = {
  selectUserAccessManagementState,
  selectError,
  selectCurrentRule,
  selectLoading,
  selectIpWhitelist,
  selectIpWhitelistItems,
  selectIpWhitelistSelectedDetail,
  selectIpWhitelistEnabled,
  selectIpWhitelistLoading,
  selectIpWhitelistDetailLoading,
  selectIpWhitelistError,
  selectIpWhitelistPagination,
  selectIpWhitelistHasData,
  selectIpWhitelistShowDetailModal,
  selectUserList,
  selectUserListUsers,
  selectUserListLoading,
  selectUserListError,
};
